import { BoundSelectField, BoundSelectFieldProps } from "@homebound/beam";
import { useMemo } from "react";
import {
  UnitsOfMeasureDataFragment,
  useUnitsOfMeasureQuery,
} from "src/components/autoPopulateSelects/UnitsOfMeasureSelectField.generated";
import { BoundAiSelectField } from "src/components/formFields/ai";
import { AiFieldProposalFormValue } from "src/components/formFields/ai/utils/aiFieldProposalForm";
import { parseAiNamedOption } from "src/components/formFields/ai/utils/bindAiProposal";
import { ObjectState } from "src/utils/formState";

type UnitsOfMeasureFieldProps = Omit<
  BoundSelectFieldProps<UnitsOfMeasureDataFragment, string>,
  "options" | "multiselect" | "getOptionLabel" | "getOptionValue"
> & {
  getOptionLabel?: (o: UnitsOfMeasureDataFragment) => string;
  getOptionValue?: (o: UnitsOfMeasureDataFragment) => string;
  optionFilter?: (options: UnitsOfMeasureDataFragment[]) => UnitsOfMeasureDataFragment[];
  aiProposal?: ObjectState<AiFieldProposalFormValue>;
};
export function UnitsOfMeasureBoundSelectField(props: UnitsOfMeasureFieldProps) {
  const {
    placeholder = "Select a Units Of Measure",
    getOptionLabel = (o) => o.name,
    getOptionValue = (o) => o.id,
    optionFilter,
    aiProposal,
    ...otherProps
  } = props;
  const { data, loading } = useUnitsOfMeasureQuery({ fetchPolicy: "cache-and-network" });
  const options = data?.unitsOfMeasure ?? [];
  // The field holds the UoM's id
  const parser = useMemo(() => parseAiNamedOption(data?.unitsOfMeasure ?? []), [data]);
  const fieldProps = {
    ...otherProps,
    placeholder: loading ? "Loading..." : placeholder,
    options: optionFilter ? optionFilter(options) : options,
    getOptionLabel,
    getOptionValue,
  };
  return aiProposal ? (
    <BoundAiSelectField {...fieldProps} aiProposal={aiProposal} parser={parser} />
  ) : (
    <BoundSelectField {...fieldProps} />
  );
}
